<template>
    <div class="mx-2 h-full">
        <div>
        <h2 class="mt-2 ml-2 text-v3-gray-800 dark:text-v3-gray-200">
            Approvals {{showIframeIndex}}
        </h2>
        <div v-if="total === 0" class="text-v3-gray-800 dark:text-v3-gray-200">
            No approvals found
        </div>
        <template v-else>
            <div class="text-sm notifications-widget" v-for="(notification, index) in notifications">
                <div class="my-2">
                    <div @mouseover="hoveringId = index" @mouseleave="hoveringId = null" @click="showPageIfApproval(notification, index)" class="p-1 bg-v3-gray-250 text-v3-gray-800 dark:bg-v3-base-700 dark:text-v3-gray-200 bg-opacity-40 dark:bg-opacity-40 rounded-xl text-center flex justify-between py-3" :class="{'rounded-b-none rounded-t-xl': notisOpen.includes(index),'cursor-pointer': getNotificationLink(notification)}">
                        <span class="inline-flex mx-4" >{{notification.entity.properties.get('title')}}</span>
                        <confirmation-action additional-button-classes=""
                                             :action="notification.entity.actions.filter(action => action.name === 'read-notification').first()"
                                             action-key="read-notification"
                                             :redirect-on-success="false"
                                             @success="readSuccess"
                                            zIndex="z-50">
                            <template v-slot:button>
                                <svg :class="{'block': hoveringId === index, 'hidden': hoveringId !== index}" class="h-4 w-4 text-white bg-red-600 rounded-full" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="m17.705 7.705l-1.41-1.41L12 10.59L7.705 6.295l-1.41 1.41L10.59 12l-4.295 4.295l1.41 1.41L12 13.41l4.295 4.295l1.41-1.41L13.41 12z"/></svg>
                            </template>
                        </confirmation-action>
                    </div>
<!--                    <div v-if="notisOpen.includes(index)" class="bg-v3-base-200 rounded-b-xl text-xs px-4 text-v3-custom dark:bg-v3-gray-150" v-html="notification.entity.properties.get('content')"></div>-->
                </div>

                <portal to="destination">
                    <large-model :removePadding="true" v-if="showIframeIndex === index && getNotificationLink(notification)" :display-confirm-button="false" @removeFromDisplay="showIframeIndex = null; currentOrder = null">
                        <iframe width="100%" v-if="!getNotificationLink(notification).includes('/orders/')" style="height:75vh" :src="getNotificationLink(notification)"></iframe>
                        <div v-else-if="currentOrder" class="overflow-hidden" style="height:85vh">
                            <single-order-details :details="currentOrder" :has-table="false" @getDetails="getOrderDetails(getNotificationLink(notification))"></single-order-details>
                        </div>
                        <loading v-else></loading>
                    </large-model>
                </portal>

            </div>
        </template>
        </div>
    </div>
</template>

<script>
import Siren from "super-siren";
import {mapGetters} from "vuex";
import ConfirmationAction from "@/v3/components/forms/ConfirmationAction.vue";
import LargeModel from "@/v3/models/LargeModel.vue";
import SingleOrderDetails from "@/v3/pages/SingleOrderDetails.vue";
import Loading from "@/components/Loading.vue";

export default{
    components: {SingleOrderDetails, ConfirmationAction, LargeModel, Loading},
    data() {
        return {
            notifications: null,
            total: 0,
            notisOpen: [],
            hoveringId: null,
            showIframeIndex: null,
            currentOrder: null
        }
    },
    props:{
        notificationsFromParent:{
            type: Object,
            default: null
        },
        notificationsTotalFromParent:{
            type: Number,
            default: null
        }
    },
    created() {
        if(this.notificationsFromParent && this.notificationsTotalFromParent){
            this.notifications = this.notificationsFromParent;
            this.total = this.notificationsTotalFromParent;
        }else {
            let follow = Siren.Helper.follow;

            Siren.Client.addHeader("Authorization", `Bearer ${this.accessToken}`);
            Siren.Client.removeHeader('Cache-Control');
            Siren.Client.addHeader('Cache-Control', 'max-age=7200');

            Siren.get(process.env.VUE_APP_API_URL + "/api/notifications?includeRead=0&approvalsOnly=1")
                .then(res => {
                    let siren = res.body;
                    this.notifications = siren.entities.filter(entity => entity.rels.contains('notification') && !entity.entity.properties.get('is_read'))
                    this.total = siren.properties.get('total')
                }, this);
        }
    },
    computed: {
        ...mapGetters({
            accessToken: "getAccessToken"
        })
    },
    methods:{
        toggleNoti(index){
            if(this.notisOpen.includes(index)){
                this.notisOpen.splice(this.notisOpen.indexOf(index), 1);
            }else{
                this.notisOpen.push(index);
            }
        },
        readSuccess(){
            if(this.notificationsFromParent && this.notificationsTotalFromParent) {
                this.$emit('readSuccess');
            }else{
                let follow = Siren.Helper.follow;

                Siren.Client.addHeader("Authorization", `Bearer ${this.accessToken}`);
                Siren.Client.removeHeader('Cache-Control');
                Siren.Client.addHeader('Cache-Control', 'max-age=7200');
                Siren.get(process.env.VUE_APP_API_URL + "/api/notifications?includeRead=0&approvalsOnly=1")
                    .then(res => {
                        let siren = res.body;
                        this.notifications = siren.entities.filter(entity => entity.rels.contains('notification') && !entity.entity.properties.get('is_read'))
                        this.total = siren.properties.get('total')
                    }, this);
            }
        },
        isTypeApproval(notification)
        {
            return notification.entity.properties.get('type') === "App\\Notifications\\ApprovalNeededNotification"
        },
        showPageIfApproval(notification, index)
        {
            if(notification.entity.properties.get('type') === "App\\Notifications\\ApprovalNeededNotification"){

            }
            console.log(this.getNotificationLink(notification));
            if(this.getNotificationLink(notification).includes('/orders/')) {
                this.getOrderDetails(this.getNotificationLink(notification));
            }
            console.log(this.currentOrder);
            this.showIframeIndex = index;
            return false;
        },
        getNotificationLink(notification) {
            let split = notification.entity.properties.get('content').split('"');
            if(split[0].endsWith('href=')){
                return process.env.VUE_APP_BASE_URL + '/' + split[1];
            }
            return null;
        },
         getOrderDetails(link){
            let url = link.split('/orders/')?link.split('/orders/')[1]: null;
             Siren.get(process.env.VUE_APP_API_URL + "/api/orders/" + url)
                .then(res => {
                    this.currentOrder = res.body;
                    return res.body;
                })
        }
    }
}
</script>
<style>
.notifications-widget a{
    text-decoration: underline;
}
</style>
